import { FC } from "react";

import { ReactComponent as SuspectedImg } from "../../../assets/illustrations/kyc-suspected-240x240.svg";
import { Button, Modal } from "../../common";

type Props = {
  isOpen: boolean;
  close: () => void;
};

export const KycSuspectModal: FC<Props> = ({ isOpen, close }) => (
  <Modal
    isOpen={isOpen}
    close={close}
    title="Additional verification needed"
    subtitle="Unfortunately we have been unable to complete your verification and your account needs to be verified by our security team."
  >
    <div className="flex flex-col items-center align-center">
      <SuspectedImg className="h-[20vh]" />

      <div className="mt-4">
        It takes up to 24 hours to verify your account by our security team
      </div>

      <Button variant={Button.variant.PRIMARY} onClick={close} className="mt-4">
        Ok, got it
      </Button>
    </div>
  </Modal>
);
